// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"80":"db52b4ae","195":"911bc082","377":"355aa84c","721":"3f046d33","938":"79a60318"}[chunkId] + ".chunk.css");